import script from "./ImagePolygonOutline.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImagePolygonOutline.vue?vue&type=script&lang=ts&setup=true"

import "./ImagePolygonOutline.vue?vue&type=style&index=0&id=6e021ee2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e021ee2"]])

export default __exports__